import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import HttpService from "@/services/HttpService";
import OwnerService from "@/services/OwnerService";
const httpService = new HttpService();
const ownerService = new OwnerService();

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    beforeEnter: checkAuth,
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    beforeEnter: checkRedirectHome,
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/Signup.vue"),
    beforeEnter: checkRedirectHome,
  },
  {
    path: "/verification/:token",
    name: "AccountVerification",
    props: true,
    component: () => import("../views/AccountVerification.vue"),
    beforeEnter: async (to: any, from: any, next: any) => {
      console.log("HEY OH", to, from);
      if (
        to.params.token == "" ||
        to.params.token == null ||
        to.params.token == undefined
      ) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/place/:placeId?",
    name: "PlaceDetails",
    props: true,
    component: () => import("../views/PlaceDetails.vue"),
    beforeEnter: async (to: any, from: any, next: any) => {
      console.log("HEY OH", to, from);
      if (
        to.params.placeId == "" ||
        to.params.placeId == null ||
        to.params.placeId == undefined
      ) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/paymentsuccess/:paymentId?",
    name: "PaymentSuccess",
    props: true,
    component: () => import("../views/PaymentSuccess.vue"),
    beforeEnter: async (to: any, from: any, next: any) => {
      if (
        to.params.paymentId == "" ||
        to.params.paymentId == null ||
        to.params.paymentId == undefined
      ) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/account",
    name: "Account",
    component: () => import("../views/Account.vue"),
  },
  {
    path: "/new-place",
    name: "AddPlace",
    component: () => import("../views/AddPlace.vue"),
  },
  {
    path: "/verification/:id",
    name: "Verification",
    component: () => import("../views/Verification.vue"),
  },
  {
    path: "/:catchAll(.*)",
    component: Home,
  },
];

/**
 * Check if user is authentified
 * If not, go to /login
 * @param to
 * @param from
 * @param next
 */
async function checkAuth(to: any, from: any, next: any) {
  const LSOwner = localStorage.getItem("owner");
  if (LSOwner) {
    const parsedOwner = JSON.parse(LSOwner);
    console.log("parsedOwner", parsedOwner);
    if (parsedOwner.uid) {
      const owner = await ownerService.getOwnerByid(parsedOwner.uid);
      if (!owner.exists) {
        // there might be a wrong id in LS
        // force logout
        ownerService.logoutOwner();
        next("/login");
      } else {
        next();
      }
    } else {
      console.log("go back to login");
      next("/login");
    }
    // blabla
  } else {
    console.log("go back to login");
    next("/login");
  }
  // if (IsAuthenticated()) next();
}

/**
 * From /login or /signup
 * Test if user is auth
 * If so, go to /
 * @param to
 * @param from
 * @param next
 */
async function checkRedirectHome(to: any, from: any, next: any) {
  console.log("hey");
  const LSOwner = localStorage.getItem("owner");
  if (LSOwner) {
    const parsedOwner = JSON.parse(LSOwner);
    console.log("parsedOwner", parsedOwner);
    if (parsedOwner.uid) {
      const owner = await ownerService.getOwnerByid(parsedOwner.uid);
      if (!owner.exists) {
        next();
      } else {
        // user is connected, go to /
        next("/");
      }
    } else {
      next();
    }
    // blabla
  } else {
    next();
  }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
